import { useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import Message from "./Message";
import ChatCard from "./ChatCard";
import axios from "axios";
import { Config } from "../../API/config";
import BasicNavbar from "../Navbar/BasicNavbar";
import { ChatType, Participant } from "../../types/chat";

const Chat = () => {
    const [isChatOpened, setIsChatOpened] = useState(false);
    const [chats, setChats] = useState<ChatType[]>([]);
    const [id, setId] = useState<string>("");
    const [reciver, setReciever] = useState<Participant[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const handleChats = async () => {
        try {
            setIsLoading(true);
            let { data } = await axios.get(`${Config.getAllChats}`, { withCredentials: true });

            console.log(data);

            if (data.statusCode === 200) {
                setChats(
                    data.data?.sort((a:ChatType, b:ChatType) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
                );
            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleChatOpened = () => {
        setIsChatOpened(false);
    };

    useEffect(() => {
        handleChats();
    }, []);

    return (
        <>
            <BasicNavbar />
            <div className="flex flex-col h-screen overflow-hidden w-full">
                <div className="w-full h-full flex">
                    {/* Main Chat Section */}
                    <div
                        className={`h-full border-r border-black overflow-y-auto transition-all duration-300 ${isChatOpened ? "w-full md:flex-1" : "hidden md:block md:flex-1"
                            }`}
                    >
                        {isChatOpened ? (
                            <Message isChatOpened={handleChatOpened} reciever={reciver} chatId={id} />
                        ) : (
                            <div className="flex items-center justify-center h-full text-gray-500 text-xl font-semibold">
                                اهلا بك في اطلب كوتش
                            </div>
                        )}
                    </div>

                    {/* Sidebar (Chat List) */}
                    <div
                        className={`h-full bg-white border-l border-black overflow-y-auto transition-all duration-300 ${isChatOpened ? "hidden md:block md:w-96" : "w-full md:w-96"
                            }`}
                    >
                        <div className="p-4 bg-white border-b-2 flex items-center justify-between">
                            <h3 className="text-xl font-semibold text-gray-800">الرسائل</h3>
                        </div>

                        {/* Chat List (With Skeletons) */}
                        {isLoading ? (
                            <div className="p-4 space-y-4">
                                {[...Array(5)].map((_, i) => (
                                    <div key={i} className="flex items-center space-x-4 animate-pulse">
                                        <div className="w-12 h-12 bg-gray-300 rounded-full"></div>
                                        <div className="flex-1 space-y-2">
                                            <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                                            <div className="h-3 bg-gray-300 rounded w-1/2"></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : chats.length ? (
                            chats.map((chat) => (
                                <div
                                    key={chat._id}
                                    onClick={() => {
                                        setIsChatOpened(true);
                                        setId(chat._id);
                                        setReciever(chat.otherParticipants);
                                    }}
                                    className="md:w-full"
                                >
                                    <ChatCard
                                        lastMessage={chat.lastMessage}
                                        unreadCound={chat.unreadCount}
                                        user={chat.otherParticipants}
                                    />
                                </div>
                            ))
                        ) : (
                            <h4 className="flex h-full w-full justify-center items-center">لا توجد محادثات</h4>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Chat;